import { useCallback, useEffect, useState } from 'react';
import { useActivityReport } from '@/hooks/app';
import { FoldingList } from '@/components/common';
import { useTranslation } from 'react-i18next';

const PAGE_SIZE = 200;

export interface ActivityReportMobileProps extends ReturnType<typeof useActivityReport> {
  fromDate: string;
  toDate: string;
}

export function ActivityReportMobile({
  total,
  lazyLoadReports,
  items,
  fetchReports,
  fromDate,
  toDate
}: ActivityReportMobileProps) {

  const [page, setPage] = useState(0);
  const [t] = useTranslation(['common', 'report']);

  useEffect(() => {
    fetchReports({
      page: 0,
      limit: PAGE_SIZE,
      fromDate,
      toDate,
      t
    });
  }, [fromDate, toDate, t]);

  const onEndReached = useCallback(() => {
    setPage((c) => {
      const newPage = c + 1;
      lazyLoadReports({ page: newPage, limit: PAGE_SIZE, fromDate, toDate, t });
      return newPage;
    });
  }, [setPage, lazyLoadReports, fromDate, toDate, t]);

  const mapped = items.map(item => ({
    title: item.name,
    description: `${item.date} ${item.time}`,
    attrs: item?.details as any,
  }));

  const hasMore = page * PAGE_SIZE < total;

  return (
    <FoldingList
      items={mapped}
      hasMore={hasMore}
      onEndReached={onEndReached}
    />
  );
}

export default ActivityReportMobile;
